<template>
  <div class="signup">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center>
          <v-flex xs12 sm8 md6>
            <v-card class="elevation-12" v-if="!userIsAuthenticated">
              <v-toolbar color="indigo" dark flat>
                <v-icon dark @click="back">mdi-arrow-left-bold</v-icon>
                <v-spacer></v-spacer>
                <v-toolbar-title>{{ $t('user_register') }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field 
                      label="Email" 
                      prepend-icon="mdi-email" 
                      type="email" 
                      v-model="email" 
                      :rules="emailRules" 
                      required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field 
                      label="Password" 
                      prepend-icon="mdi-textbox-password" 
                      v-model="password" 
                      :rules="passwordRules" 
                      required 
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                      :type="show1 ? 'text' : 'password'" 
                      counter
                      @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field 
                      label="Confirm Password" 
                      prepend-icon="mdi-textbox-password" 
                      v-model="confirmPassword" 
                      :rules="passwordRules" 
                      required 
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" 
                      :type="show2 ? 'text' : 'password'" 
                      counter
                      @click:append="show2 = !show2"
                      ></v-text-field>
                    </v-flex>
                    <v-flex x12>
                      <div class='onesignal-customlink-container'></div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-text>{{ $t('have_account') }} <router-link to="/signin"> {{ $t('navigation_signin') }}</router-link> </v-text>
                <v-spacer></v-spacer>
                <v-btn rounded color="indigo" dark @click="register()">{{ $t('navigation_signup') }}</v-btn>
              </v-card-actions>
              <span  v-if="!userIsAuthenticated">
                <v-toolbar-title><b style="padding-left: 15px: color: grey;">{{ $t('alt_sign') }}:</b></v-toolbar-title>
                <v-btn class="ma-2" @click="googlesignup()">
                  <img src="@/assets/googleicon.png" alt="Google" width="30" />
                </v-btn>
                <v-btn class="ma-2" @click="facebooksignup()">
                  <img src="@/assets/facebook.jpg" alt="Facebook" width="30" />
                </v-btn>
                <v-btn class="ma-2" @click="twittersignup()">
                  <img src="@/assets/twitter.jpg" alt="Twitter" width="30" />
                </v-btn>
                <v-btn class="ma-2" @click="yahoosignup()">
                  <img src="@/assets/yahoo.jpg" alt="yahoo" width="30" />
                </v-btn>
              </span>         
            </v-card>
            <v-card class="elevation-12" v-if="userIsAuthenticated">
              <v-divider></v-divider>
              <v-toolbar flat>
                <v-toolbar-title>Welcome to Convergeo,<br><div class="label">{{email}}</div></v-toolbar-title>
              </v-toolbar>
              <v-card-actions>
                <router-link to="dashboard/home"><v-btn rounded color="success" class="mr-4"><v-icon>mdi-home</v-icon>Dashboard</v-btn></router-link>
                <v-spacer></v-spacer>
                <v-btn rounded color="indigo" dark @click="back"><v-icon>mdi-arrow-left-bold</v-icon>Back</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
  import {fb,db,ath,auth} from '@/firebase'

  export default {
    name: "signup",
    data: () => ({
      show1: false,
      show2: false,
      drawer: null,
      user: null,
      valid: true,
      nav_title: 'Sign Up',
      password: '',
      confirmPassword: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Name must be more than 6 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ]
    }),
    computed: {
      userIsAuthenticated () {
        return this.user !== null && this.user !== undefined
      }
    },
    methods: {
      back(){
        this.$router.go(-1)
      },
      googlesignup () {
        const gprovider = new ath.GoogleAuthProvider()
        auth.signInWithPopup(gprovider)
        .then((result) => {
          /* eslint-disable */
          const token = result.credential.accessToken
          const user = result.user
          /* eslint-enable */
        })
        .then(() => {
          this.$router.replace('/signup_extra')
        })
        /* eslint-disable */
        // .then((user) => {
        //   db.collection("user").doc(user.user.uid).set({
        //     name: this.name,
        //     phone: this.phone
        //   })
        //   .then(() => {
        //     /* eslint-disable no-console */
        //       console.log("Document sucessfully written!");
        //       /* eslint-enable no-console */
        //       /* eslint-disable */
        //       Toast.fire({
        //         type: 'success',
        //         title: 'Successfully Signed In, Thank You.'
        //       })
        //      /* eslint-enable */
        //   })
        //   .catch((error) => {
        //     /* eslint-disable no-console */
        //       console.error("Error writing document: ", error);
        //     /* eslint-enable no-console */
            
        //   });
        //   // this is where it ends can it be translated to the users.
        //   this.$router.replace('dashboard/home');
        // })
        /* eslint-enable */
        .catch((error) => {
          /* eslint-disable */
          const errorCode = error.code
          const errorMessage = error.message
          const email = error.email
          const credential = error.credential
          /* eslint-enable */
        })
      },
      facebooksignup () {
        const fprovider = new ath.FacebookAuthProvider()
        auth.signInWithPopup(fprovider)
        .then((result) => {
          /* eslint-disable */
          const token = result.credential.accessToken
          const user = result.user
          /* eslint-enable */
        })
        .then(() => {
          this.$router.replace('/signup_extra')
        })
        /* eslint-disable */
        // .then((user) => {
        //   db.collection("user").doc(user.user.uid).set({
        //     name: this.name,
        //     phone: this.phone
        //   })
        //   .then(() => {
        //     /* eslint-disable no-console */
        //       console.log("Document sucessfully written!");
        //       /* eslint-enable no-console */
        //       /* eslint-disable */
        //       Toast.fire({
        //         type: 'success',
        //         title: 'Successfully Signed In, Thank You.'
        //       })
        //      /* eslint-enable */
        //   })
        //   .catch((error) => {
        //     /* eslint-disable no-console */
        //       console.error("Error writing document: ", error);
        //     /* eslint-enable no-console */
            
        //   });
        //   // this is where it ends can it be translated to the users.
        //   this.$router.replace('dashboard/home');
        // })
        /* eslint-enable */
        .catch((error) => {
          /* eslint-disable */
          const errorCode = error.code
          const errorMessage = error.message
          const email = error.email
          const credential = error.credential
          /* eslint-enable */
        })
      },
      twittersignup () {
        const tprovider = new ath.TwitterAuthProvider()
        auth.signInWithPopup(tprovider)
        .then((result) => {
          /* eslint-disable */
          const token = result.credential.accessToken
          const user = result.user
          /* eslint-enable */
        })
        .then(() => {
          this.$router.replace('/signup_extra')
        })
        /* eslint-disable */
        // .then((user) => {
        //   db.collection("user").doc(user.user.uid).set({
        //     name: this.name,
        //     phone: this.phone
        //   })
        //   .then(() => {
        //     /* eslint-disable no-console */
        //       console.log("Document sucessfully written!");
        //       /* eslint-enable no-console */
        //       /* eslint-disable */
        //       Toast.fire({
        //         type: 'success',
        //         title: 'Successfully Signed In, Thank You.'
        //       })
        //      /* eslint-enable */
        //   })
        //   .catch((error) => {
        //     /* eslint-disable no-console */
        //       console.error("Error writing document: ", error);
        //     /* eslint-enable no-console */
            
        //   });
        //   // this is where it ends can it be translated to the users.
        //   this.$router.replace('dashboard/home');
        // })
        /* eslint-enable */
        .catch((error) => {
          /* eslint-disable */
          const errorCode = error.code
          const errorMessage = error.message
          const email = error.email
          const credential = error.credential
          /* eslint-enable */
        })
      },
      yahoosignup () {
        const yprovider = new ath.OAuthProvider('yahoo.com')
        auth.signInWithPopup(yprovider)
        /* eslint-disable */
        // .then((user) => {
        //   db.collection("user").doc(user.user.uid).set({
        //     name: this.name,
        //     phone: this.phone
        //   })
        //   .then(() => {
        //     /* eslint-disable no-console */
        //       console.log("Document sucessfully written!");
        //       /* eslint-enable no-console */
        //       /* eslint-disable */
        //       Toast.fire({
        //         type: 'success',
        //         title: 'Successfully Signed In, Thank You.'
        //       })
        //      /* eslint-enable */
        //   })
        //   .catch((error) => {
        //     /* eslint-disable no-console */
        //       console.error("Error writing document: ", error);
        //     /* eslint-enable no-console */
            
        //   });
        //   // this is where it ends can it be translated to the users.
        //   this.$router.replace('dashboard/home');
        // })
        /* eslint-enable */
        .then(() => {
          this.$router.replace('/signup_extra')
        })
        .catch(error => {
          /* eslint-disable */
          console.log(error)
          /* eslint-enable */
        })
      },
      async register() {
        try { 
          let email = this.email.toString().trim()
          let password = this.password.toString().trim()
          let confirmPassword = this.confirmPassword.toString().trim()
          if(password != confirmPassword){
            alert("The passwords do not match!")
          }
          else{
            auth.createUserWithEmailAndPassword(email, password)
            /* eslint-disable */
            // .then((user) => {
            //   db.collection("user").doc(user.user.uid).set({
            //     name: this.name,
            //     phone: this.phone
            //   })
            //   .then(() => {
            //     /* eslint-disable no-console */
            //       console.log("Document sucessfully written!");
            //       /* eslint-enable no-console */
            //       /* eslint-disable */
            //       Toast.fire({
            //         type: 'success',
            //         title: 'Successfully Signed In, Thank You.'
            //       })
            //      /* eslint-enable */
            //   })
            //   .catch((error) => {
            //     /* eslint-disable no-console */
            //       console.error("Error writing document: ", error);
            //     /* eslint-enable no-console */
                
            //   });
            //   // this is where it ends can it be translated to the users.
            //   this.$router.replace('dashboard/home');
            // })
            /* eslint-enable */
            .then(() => {
              this.$router.replace('/signup_extra')
            })
            .catch((error) =>{
              /* eslint-disable */
              console.log("An error occured!")
              console.log(error.code)
              console.log(error.message)
              /* eslint-enable */
            })
          }
        } 
        catch (error) {
          /* eslint-disable */
          console.log(error.message)
          /* eslint-enable */
        }
      }
    },
    created () {
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id
        })
      })
    }
  }
</script>